module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/UnavailableBattle/images/bg-content.4832e784.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/UnavailableBattle/images/bg-content.png
// module id = 2527
// module chunks = 11